export const TABLE_DATA = {
  heading: "Onemind’s IaaS vs. Traditional IT Infrastructure",
  columns: ["Onemind’s IaaS", "Traditional IT Infrastructure"],
  data: [
    {
      feature: "Scalability",
      "Onemind’s IaaS": "✅ Dynamic Scaling",
      "Traditional IT Infrastructure": "❌ Limited by Hardware",
    },
    {
      feature: "Upfront Cost",
      "Onemind’s IaaS": "✅ Pay-as-you-go",
      "Traditional IT Infrastructure": "❌ High CAPEX",
    },
    {
      feature: "Security & Compliance",
      "Onemind’s IaaS": "✅ Advanced Security",
      "Traditional IT Infrastructure": "❌ Requires Manual Setup",
    },
    {
      feature: "Backup & Disaster Recovery",
      "Onemind’s IaaS": "✅ Automated DRaaS",
      "Traditional IT Infrastructure": "❌ Manual Recovery",
    },
    {
      feature: "Global Accessibility",
      "Onemind’s IaaS": "✅ Cloud-Based, Remote Access",
      "Traditional IT Infrastructure": "❌ Local Access Only",
    },
  ],
};
